import React from "react";
import { useLocation } from "react-router-dom";
import "./PageTransition.css";

export const PageTransition = ({ children }) => {
  const location = useLocation();
  
  return (
    <div key={location.pathname} className="page-transition">
      {children}
    </div>
  );
};

